export const expiredSession = {
	cardTitle: "For your safety, your session has been expired.",
	loginButtonLabel: "Log back in",
};
